export const truncateString = (title: string, target: number): string => {
    return title.length >= target ? `${title.slice(0, target)}…` : title;
};